import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit, Close as IconClose } from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import TxtBox from "components/Custom/TxtBox";
import SkeletonBox from "components/Custom/SkeletonBox";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";
import TxtRow from "components/Custom/TxtRow";
import { API_CONFIG, CONFIG, NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { DEFAULTS } from "common/config";
import {
  LABELS,
  WARNINGS,
  TITLES,
  SUCCESS,
  ERRORS,
  SUB_TITLES,
} from "common/lables";
import { COMMON_JS } from "common/scripts";

import { TRANS_APIs } from "apihandlers/transaction";
import { AUTH_APIs } from "apihandlers/auth";

const thumbnailImg = require("assets/images/pdf.png");

const CreditApproval = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "refNumber",
      name: LABELS.REFERENCE_NO,
      width: "10%",
      type: "text",
      align: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "amount",
      name: LABELS.AMOUNT,
      width: "10%",
      type: "text",
      align: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "remarks",
      name: LABELS.REMARKS,
      width: "15%",
      type: "number",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "file", //todo getfile pending
      name: LABELS.FILE,
      width: "20%",
      type: "number",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "sapReference",
      name: LABELS.SAP_REFERENCE,
      width: "10%",
      type: "text",
      align: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "approvalAmount",
      name: LABELS.APPROVED_AMOUNT,
      width: "10%",
      type: "text",
      align: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "approvalRemarks",
      name: LABELS.APPROVAL_COMMENT,
      width: "15%",
      type: "number",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await TRANS_APIs.getCreditNote(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getRegions:", error);
    }
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    console.log(selectedRow);
  };

  const manageCreditNote = () => {
    const remarks = (
      document.getElementById("remarks") as HTMLInputElement
    ).value.trim();
    const refNumber = (
      document.getElementById("refNumber") as HTMLInputElement
    ).value.trim();
    const amount = (
      document.getElementById("amount") as HTMLInputElement
    ).value.trim();
    const approvalAmount = (
      document.getElementById("approvalAmount") as HTMLInputElement
    ).value.trim();
    const sapReference = (
      document.getElementById("sapReference") as HTMLInputElement
    ).value.trim();
    const approvalRemarks = (
      document.getElementById("approvalRemarks") as HTMLInputElement
    ).value.trim();
    let ele = document.querySelector(
      'input[name="status"]:checked'
    ) as HTMLInputElement;
    const status = ele ? ele.value : "";

    const errors = [];
    if (refNumber === "") {
      errors.push({
        id: "refNumber",
        msg:
          "<span class='bold'>" +
          LABELS.REFERENCE_NO +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (amount === "") {
      errors.push({
        id: "amount",
        msg:
          "<span class='bold'>" +
          LABELS.AMOUNT +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (remarks === "") {
      errors.push({
        id: "remarks",
        msg:
          "<span class='bold'>" +
          LABELS.REMARK +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      orgId: 16,
      refNumber: selectedRow.refNumber,
      amount: selectedRow.amount,
      remarks: selectedRow.remarks,
      sapReference,
      approvalAmount,
      approvalRemarks,
      status,
    };
    setIsSubmit(true);
    TRANS_APIs.manageCreditNote(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  console.log("Page: Credit Approval:");

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => props.setDashMenu(LABELS.HOME)}>
            {LABELS.ACCOUNT}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.CREDIT_APPROVAL}</li>
        </ul>
        <h4>{TITLES.CREDIT_APPROVAL}</h4>
        <p>{SUB_TITLES.CREDIT_APPROVAL}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={"creditApproval"}
            height={window.innerHeight * 0.8}
            cols={columns}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.CREDIT_APPROVAL}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.CREDIT_NOTE + ": " + selectedRow.id
              : "Add New " + LABELS.CREDIT_NOTE
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="formGroup ">
            <TxtRow
              id={"refNumber"}
              label={LABELS.REFERENCE_NO}
              defaultValue={selectedRow.refNumber}
              disabled={true}
            />
          </div>
          <div className="formGroup ">
            <TxtRow
              id={"amount"}
              label={LABELS.AMOUNT}
              defaultValue={selectedRow.amount}
              disabled={true}
            />
          </div>
          <div className="formGroup">
            <TxtRow
              id={"remarks"}
              type={"text"}
              label={LABELS.REMARKS}
              defaultValue={selectedRow.remarks}
              disabled={true}
            />
          </div>

          <div className="formGroup ">
            <TxtRow
              id={"sapReference"}
              type={"text"}
              required={true}
              label={LABELS.SAP_REFERENCE}
              defaultValue={selectedRow.sapReference}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup ">
            <TxtRow
              id={"approvalAmount"}
              type={"number"}
              required={true}
              label={LABELS.APPROVED_AMOUNT}
              defaultValue={selectedRow.approvalAmount}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup">
            <TxtRow
              id={"approvalRemarks"}
              type={"text"}
              required={true}
              label={LABELS.APPROVAL_COMMENT}
              defaultValue={selectedRow.approvalRemarks}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup required">
            <label>
              {LABELS.STATUS}
              {<span>{"*"}</span>}
            </label>
            <RadioBtn
              list={[
                {
                  id: "reject",
                  label: LABELS.REJECT,
                  value: LABELS.REJECT,
                  checked: selectedRow.id
                    ? selectedRow.status === "reject"
                    : false,
                  disabled: false,
                },
                {
                  id: "approve",
                  label: LABELS.APPROVE,
                  value: LABELS.APPROVE,
                  checked: selectedRow.id
                    ? selectedRow.status === "approve"
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"status"}
              disabled={isSubmit}
            />
          </div>
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          <div className="formGroup submitBtnWrapper">
            <div className="flexbtnjustify">
              <Btn
                text={LABELS.CANCEL}
                loading={isSubmit}
                bgColor={COLORS.RELOAD_EXPORT}
                color={COLORS.RELOAD_EXPORT_TEXT}
                onClick={() => {
                  setManageDialog(false);
                  setMandatoryResults([]);
                }}
              />
              <Btn
                text={LABELS.SAVE}
                loading={isSubmit}
                onClick={manageCreditNote}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(CreditApproval);
